/*
 * There is a zero-width-space character here (\u200B) which is
 * used to capture the line-height applied to containers. This is
 * especially useful for flex containers where an icon or input
 * needs to remain in line with the first line of text in the
 * accompanying flex child.
 *
 *  _____________________________________________________________________________
 *  |           flex box (row, align-items: start)                               |
 *  | |‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾|                   |‾‾‾‾‾‾‾‾‾‾‾‾‾‾| |
 *  | | flex box (row, align-items: center) | Height set by     |              | |
 *  | |         icon     \u200B             | \u200B if it's    |     text     | |
 *  | |        [_⬍_]      [_⬍_]             | bigger than icon. |       ⬆      | |
 *  | | ____________________________________| Icon is centered  |______________| |
 *  |                                         within that space                  |
 *  |____________________________________________________________________________|
 *
 * In code, this looks like:
 * ```jsx
 * import {
 *   HStack,
 *   Icon,
 *   Text,
 *   ZERO_WIDTH_SPACE_CHARACTER
 * } from '@packages/systems/spring';
 *
 * const Example = () => {
 *   return (
 *     <HStack align="start">
 *       <HStack align="center">
 *         <Icon/>
 *         <Text>{ZERO_WIDTH_SPACE_CHARACTER}</Text>
 *       </HStack>
 *       <Text>the text to align the icon with</Text>
 *     </HStack>
 *   );
 * }
 * ```
 */
export const ZERO_WIDTH_SPACE_CHARACTER = '​';
